import styled from "styled-components";

export const Wrapper = styled.div`
  .advance-search {
    background: #fff;
    padding: 10px;
    border-radius: 3px;
    /* box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.2); */
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .advance-search .desc {
    font-size: 15px;
    color: #999;
    display: block;
    margin-bottom: 26px;
  }
`;

